var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8_patch_hash=c5t5wnxp6mvabdrpn7wm4zt2zu/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<li class=\"empty-list-message\">"
    + container.escapeExpression(container.lambda(container.strict(depth0, "empty_list_message", {"start":{"line":1,"column":33},"end":{"line":1,"column":51}} ), depth0))
    + "</li>\n";
},"useData":true});